import React from 'react'
export const plans = [
  {
    title: "Starter",
    plan_type: 'subscription',
    title_plus: 'Starter',
    subtitle: "For new sellers",
    identifier: 'starter',
    description:
      "32 credits a month. Approx. 8 products a month",
    price: 304,
    priceMonthly: 352,
    annualPeriod: "/month",
    images_dec: "15 images monthly at $42/image",
    annual_images_dec: "240 images annually at $35/image",
    monthlyPeriod: "Billed annually. $38 per product",
    priceAnnual: 3648,
    monthlyPlusPeriod: "Billed monthly. $44 per product",
    buttonText: "Proceed to Payment",
    buttonLink: "https://app.all3d.ai/register",
    discount: "22% discount on bundle price",
    discount_monthly: "14% off the bundle price",
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "240 4K images annually",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",
    ],
    monthly_features: ["8 products a month",
      "Unlimited 1K image generations",
      "20 4K images monthly",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",],

    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props",
    ],
    get_more_toggle: true,
    get_more_text: "4 credits per product. All 384 credits available immedietely.",
    get_more_text_monthly: "4 credits per product. 32 credits available monthly.",
    package_type: "Starter",
    plan_name: "starter_ai",
    plan_plus_name: "starter_ai",
    annual_plan_name: "annual_starter_ai",
    credits_details: <span>Your purchase includes <b>32 credits</b> each month, redeemable at <b>4 credits per product</b>. Unused credits roll over up to 3 months before expiring.</span>,
    annual_credits_details: <span>Your purchase includes all <b>384 credits</b> upfront, redeemable at <b>4 credits per product</b>. Unused credits expire 1 year from the subscription start date. No rollovers.</span>,
    feature_table: [
      { name: "Product uploads", value: "8/month or 96/annually" },
      { name: "Image generations", value: "Unlimited" },
      { name: "Final 2K or 4K images (no watermark)", value: "4 per product" },
      { name: "Video generation from final image (720p)", value: "2 credits each" },
      { name: "Multiple aspect ratios", value: "Square, Landscape, Portrait" },
      { name: "User licenses", value: "3" },
      // { name: "Asset management", included: true },
      // { name: "Sharing & cloud storage", included: true },
      // { name: "Live onboarding session", included: true },
      // { name: "Managed design services", included: false },
      // { name: "Dedicated support", included: false },
      // { name: "Account manager", included: false }
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },

      { name: "Review Gallery (for quality managemet)", included: true },
      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: 3 },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },
      { name: "Live onboarding session", included: false },
      { name: "Managed design services", included: false },
      { name: "Dedicated support", included: false },
      { name: "Account manager", included: false }
    ]
  },
  {
    title: "Growth",
    plan_type: 'subscription',
    title_plus: "Growth",
    subtitle: "For growing sellers",
    description:
      "64 credits a month. Approx. 16 products a month",

    price: 576,
    priceMonthly: 680,
    priceAnnual: 6912,
    annualPeriod: "/month   ",
    monthlyPeriod: "Billed annually. $36 per product",
    monthlyPlusPeriod: "Billed monthly. $42.5 per product",
    images_dec: "25 images monthly at $42/image",
    annual_images_dec: "300 images annually at $35/image",
    buttonText: "Proceed to Payment",
    buttonLink: "https://app.all3d.ai/register",
    discount: "26% off the bundle price",
    discount_monthly: "14% off the bundle price",
    featuresHeading: "Includes",
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "600 4K images annually",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",
    ],
    monthly_features: ["Approx. 16 products a month",
      "Unlimited image generations",
      "Approx. 8 products a month",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",
    ],
    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props",
    ],
    get_more_toggle: true,
    get_more_text: "4 credits per product. All 768 credits available immedietely.",
    get_more_text_monthly: "4 credits per product. 64 credits available monthly.",
    package_type: "Growth",
    plan_name: "growth_ai",
    plan_plus_name: "growth",
    annual_plan_name: "annual_growth_ai",
    credits_details: <span>Your purchase includes <b>64 credits</b> each month, redeemable at <b>4 credits per product</b>. Unused credits roll over up to 3 months before expiring.</span>,
    annual_credits_details: <span>Your purchase includes all <b>768 credits</b> upfront, redeemable at <b>4 credits per product</b>. Unused credits expire 1 year from the subscription start date. No rollovers.</span>,
    feature_table: [
      { name: "Product uploads", value: "16/month or 192/annually" },
      { name: "Image generations", value: "Unlimited" },
      { name: "Final 2K or 4K images (no watermark)", value: "4 per product" },
      { name: "Video generation from final image (720p)", value: "2 credits each" },
      { name: "Multiple aspect ratios", value: "Square, Landscape, Portrait" },
      { name: "User licenses", value: "6" },
      { name: "Asset management", included: true },
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },
      { name: "Brand guidelines support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (for quality managemet)", included: true },

      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: 9 },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },

      { name: "Live onboarding session", included: true },
      { name: "Managed design services", included: false },
      { name: "Dedicated support", included: false },
      { name: "Account manager", included: false }
    ]
  },
  {
    title: "Pro",
    plan_type: 'subscription',
    title_plus: "Pro",
    subtitle: "For pro sellers",
    description:
      "256 credits a month. Approx. 64 products a month",
    price: 2176,
    priceMonthly: 2624,
    priceAnnual: 26112,
    annualPeriod: "/month   ",
    monthlyPeriod: "Billed annually. $34 per product",
    monthlyPlusPeriod: "Billed monthly. $41 per product",
    images_dec: "50 images monthly at $42/image",
    annual_images_dec: "600 images annually at $35/image",
    buttonText: "Proceed to Payment",
    buttonLink: "https://app.all3d.ai/register",
    discount: "30% off the bundle price",
    discount_monthly: "14% off the bundle price",
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "600 4K images annually",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",
    ],
    monthly_features: [
      "Appox. 64 products a month",
      "Unlimited 1K image generations",
      "50 4K images monthly",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage"
    ],
    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props",
    ],
    get_more_toggle: true,
    get_more_text: "4 credits per product. All 3072 credits available immedietely.",
    get_more_text_monthly: "4 credits per product. 256 credits available monthly.",
    package_type: "Pro",
    plan_name: "pro_ai",
    plan_plus_name: "pro",
    annual_plan_name: "annual_pro_ai",
    credits_details: <span>Your purchase includes <b>256 credits</b> each month, redeemable at <b>4 credits per product</b>. Unused credits roll over up to 3 months before expiring.</span>,
    annual_credits_details: <span>Your purchase includes all <b>3,072 credits</b> upfront, redeemable at <b>4 credits per product</b>. Unused credits expire 1 year from the subscription start date. No rollovers.</span>,
    feature_table: [
       { name: "Product uploads", value: "64/month  or 768/annually" },
      { name: "Image generations", value: "Unlimited" },
      { name: "Final 2K or 4K images (no watermark)", value: "4 per product" },
      { name: "Video generation from final image (720p)", value: "2 credits each" },
      { name: "Multiple aspect ratios", value: "Square, Landscape, Portrait" },
      { name: "User licenses", value: "Unlimited" },
      { name: "Asset management", included: true },
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },
      { name: "Bulk uploads", included: true },

      { name: "Brand guidelines support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (for quality managemet)", included: true },

      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: "Unlimited" },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },

      { name: "Live onboarding session", included: true },
      { name: "Managed design services", included: true },
      { name: "Dedicated support", included: true },
      { name: "Account manager", included: false }
    ]
  },
  {
    title: "Enterprise",
    plan_type: 'subscription',
    subtitle: "For large teams",
    description:
      "Custom plan with 3D/AR",
    price: "Let's talk",
    priceAnnual: "",
    priceMonthly: "",
    annualPeriod: "",
    monthlyPeriod: "Schedule a time to discuss",
    monthlyPlusPeriod: "Schedule a time to discuss",
    images_dec: "Custom 4K images",
    annual_images_dec: "Custom 4K images",
    buttonText: "Schedule a demo",
    buttonLink: "https://all3d.ai/contact-us",
    monthly_features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "Custom 4K images annually",
      "Multiple user licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Live onboarding session",
      "Managed design services",
      "Dedicated support",
      "Account manager"
    ],
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "Custom 4K images annually",
      "Multiple user licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Live onboarding session",
      "Managed design services",
      "Dedicated support",
      "Account manager"
    ],

    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props",
      "Photorealistic 3D models",
      "AR view in room",
      "Product silo images",
      "3D CGI images",
      "Custom scenes",
      "API integration",
      "3D configurator",
      "Project management",
      "Team collaboration"
    ],

    get_more_toggle: false,
    get_more_text: <a href="https://all3d.ai/contact-us">Contact us</a>,
    package_type: "Enterprise",
    plan_name: "enterprise",
    plan_plus_name: "enterprise",
    annual_plan_name: "enterprise",
    credits_details: "",
    annual_credits_details: "",
    discount: "",
    discount_monthly: "",
    feature_table: [
      { name: "Product uploads", value: "Custom" },
      { name: "Image generations", value: "Unlimited" },
      { name: "Final 2K or 4K images (no watermark)", value: "4 per product" },
      { name: "Video generation from final image (720p)", value: "2 credits each" },
      { name: "Multiple aspect ratios", value: "Square, Landscape, Portrait" },
      { name: "User licenses", value: "Unlimited" },
      { name: "Asset management", included: true },
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },
      { name: "Bulk uploads", included: true },

      { name: "Brand guidelines support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (for quality managemet)", included: true },

      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: "Unlimited" },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },
      { name: "API Integration", included: true },


      { name: "Live onboarding session", included: true },
      { name: "Managed design services", included: true },
      { name: "Dedicated support", included: true },
      { name: "Account manager", included: false },
    
      { name: "Photorealistic 3D models", included: true, is3DFeature: true },
      { name: "AR view in room", included: true, is3DFeature: true },
      { name: "Product silo images", included: true, is3DFeature: true },
      { name: "3D CGI images", included: true, is3DFeature: true },
      { name: "3D Custom scenes", included: true, is3DFeature: true },
      { name: "3D configurator", included: true, is3DFeature: true },
      { name: "Project management", included: true, is3DFeature: true },
    ]
  },
];

export const bundles = [
  {
    title: "Basic Bundle",
    plan_type: 'bundle',
    identifier: 'basic_ai',
    subtitle: "For self-serve users",
    description:
      "Flexible & easy-to-manage.",
    price: 49,
    buttonText: "Buy",
    image_length: '5 image minimum',
    min_quantity: 5,
    credit_multiplier: 4,
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "Custom (5 minimum) 4K images",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Live onboarding session",
    ],
    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props"
    ],
    package_type: 'AI Creator',
    name: 'basic_ai',
    credits_details: <span>Your purchase includes <b>20 credits</b> each month, redeemable at <b>4 credits per product</b>. Unused credits expire 1 year from the purchase date. No rollovers.</span>,
    feature_table: [
      { name: "Product uploads", value: "Unlimited" },
      { name: "1K image generations", value: "Unlimited" },
      { name: "4K images", value: "Custom" },
      { name: "User licenses", value: "2" },
     
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },

      { name: "Review Gallery (for quality managemet)", included: true },
      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: 3 },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },
      { name: "Live onboarding session", included: false },
      { name: "Managed design services", included: false },
      { name: "Dedicated support", included: false },
      { name: "Account manager", included: false }
    ]
  },
  {
    title: "Studio Bundle",
    plan_type: 'bundle',
    identifier: 'studio_ai',
    alert: "Popular",
    subtitle: "For low-touch users",
    description: "Designer-guided & managed",
    price: 110,
    buttonText: "Buy",
    image_length: '45 image minimum',
    min_quantity: 45,
    credit_multiplier: 12,
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "Custom (165 minimum) 4K images",
      "2 user licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Live onboarding session",
      "Managed design services",
      "Dedicated support",
    ],
    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props"
    ],
    package_type: 'PDP Basic',
    name: 'studio_ai',
    credits_details: <span>Your purchase includes <b>1980 credits</b> each month, redeemable at <b>4 credits per product</b>. Unused credits expire 1 year from the purchase date. No rollovers.</span>,
    feature_table: [
      { name: "Product uploads", value: "Unlimited" },
      { name: "1K image generations", value: "Unlimited" },
      { name: "4K images", value: "Custom" },
      { name: "User licenses", value: "2" },
     
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },

      { name: "Review Gallery (for quality managemet)", included: true },
      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: 6 },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },
      { name: "Live onboarding session", included: true },
      { name: "Managed design services", included: true },
      { name: "Dedicated support", included: true },
      { name: "Account manager", included: false }
    ]
  },
  {
    title: "Enterprise",
    plan_type: 'bundle',
    subtitle: "For large teams",
    description:
      "Custom plan with 3D & AR",
    price: 0,
    buttonText: "Schedule a demo",
    image_length: 'Schedule a time to discuss',
    min_quantity: 1,
    features: [
      "Unlimited product uploads",
      "Unlimited 1K image generations",
      "Custom 4K images",
      "Multiple user licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Live onboarding session",
      "Managed design services",
      "Dedicated support",
      "Account manager",
    ],
    plus_features: [
      "Resize product",
      "Magic erase",
      "Replace items",
      "Upload inspiration",
      "Upload props",
      "Photorealistic 3D models",
      "AR view in room",
      "Product silo images",
      "3D CGI images",
      "Custom scenes",
      "API integration",
      "3D configurator",
      "Project management",
      "Team collaboration",
    ],
    package_type: 'PDP Pro',
    name: 'pdp_pro',
    credits_details: "",
    get_more_text: <a href="https://all3d.ai/contact-us">Contact us</a>,
    feature_table: [
      { name: "Product uploads", value: "Unlimited" },
      { name: "1K image generations", value: "Unlimited" },
      { name: "4K images", value: "Custom" },
      { name: "User licenses", value: "Multiple" },
     
    ],
    advanced_feature_table: [
      { name: "Editing", included: true },
      { name: "Resize product", included: true },
      { name: "Magic erase", included: true },
      { name: "Replace items", included: true },
      { name: "Color correction", included: true },
      { name: "Texture transfer (small items, logos etc)", included: true },
      { name: "Upload inspiration", included: true },
      { name: "Upload props", included: true },
      { name: "Bulk uploads", included: true },

      { name: "Brand guidelines support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (for quality managemet)", included: true },

      { name: "Team collaboration", included: true },
      { name: "User Management", included: true },
      { name: "Asset management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: "Unlimited" },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Sharing & cloud storage", included: true },
      { name: "API Integration", included: true },

      { name: "Live onboarding session", included: true },
      { name: "Managed design services", included: true },
      { name: "Dedicated support", included: true },
      { name: "Account manager", included: true },

      { name: "Photorealistic 3D models", included: true, is3DFeature: true },
      { name: "AR view in room", included: true, is3DFeature: true },
      { name: "Product silo images", included: true, is3DFeature: true },
      { name: "3D CGI images", included: true, is3DFeature: true },
      { name: "3D Custom scenes", included: true, is3DFeature: true },
      { name: "3D configurator", included: true, is3DFeature: true },
      { name: "Project management", included: true, is3DFeature: true },
    ]
  },
];

export const nextSubscription = {
  'Free Trial': {
    'display_name': 'Starter',
    'name': 'Growth',
    'monthly_link': 'https://app.all3d.ai/register',
    'annual_link': '',
    'plan_name': 'starter_ai',
  },
  'Starter': {
    'display_name': 'Growth',
    'name': 'Growth',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'growth_ai',
  },
  'Growth': {
    'display_name': 'Pro',
    'name': 'Pro',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'pro_ai',
  },
  'Pro': {
    'display_name': 'Enterprise',
    'name': 'Enterprise',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'enterprise',
  }
}

export const nextBundle = {
  'Free Trial': {
    'name': 'Basic Bundle',
    'link': 'https://app.all3d.ai/register',
  },
  'Basic Bundle': {
    'name': 'Studio Bundle',
    'link': '',
  },
  'Studio Bundle': {
    'name': 'Enterprise',
    'link': '',
  },
}


export const users = [
  {
    icon: "/amazon_icon.svg",
    title: "Amazon Sellers",
    description:
      "Get all your listing photography and AR view in room in one place.",
  },
  {
    icon: "/basket.svg",
    title: "Online DTC Brands",
    description:
      "Easily create product and lifestyle photos to use on your ecommerce site and marketing on social media channels.",
  },
  {
    icon: "/solar_shop.svg",
    title: "Large Retailers",
    description:
      "Get all your manufacturer models in one place to create multi-vendor lifestyle content quickly and easily.",
  },
  {
    icon: "/clarity_factory.svg",
    title: "Manufacturers",
    description:
      "Create prototypes of products, show your products in beautiful spaces and generate all your virtual content in one place.",
  },
  {
    icon: "/pencil_scale.svg",
    title: "Interior Designers",
    description:
      "Create photorealistic images, 360s and 3D tours of designs for your clients. Quickly create engaging social media content.",
  },
  {
    icon: "/real_estate.svg",
    title: "Real Estate Agencies",
    description:
      "Create 3D room tours and photorealistic staging images of high-profile listings to reach more potential clients.",
  },
];

export const brands = [
  { name: "Anthony", path: "/brands/nathan_anthony.svg" },
  { name: "Novogratz", path: "/brands/novogratz.svg" },
  { name: "Skyline Furniture", path: "/brands/skyline.svg" },
  { name: "Safavieh", path: "/brands/safavieh.svg" },
  { name: "RH", path: "/brands/rh_logo.svg" },
  { name: "Walmart", path: "/brands/wallmart.svg" },
  { name: "The Home Depot", path: "/brands/the_home_depot.svg" },
  { name: "Uttermost", path: "/brands/uttermost.svg" },
  { name: "Basset", path: "/brands/basset.svg" },
  { name: "hooker", path: "/brands/hooker.svg" },
];

export const features = [
  {
    title: "3D/AR Model Creation",
    description:
      "It all starts with creating accurate 3D models of your products and variants.",
    image: "/features/feature_chair.png",
    featuresList: [
      {
        title: "3D product models",
        description:
          "High-quality, accurate 3D models of your products we create or you can upload",
      },
      {
        title: "Product variants",
        description:
          "Multiple variants or SKUs of your product in different colors, materials, etc.",
      },
      {
        title: "AR product models",
        description:
          "Realistic AR product models for your PDP's view in room feature",
      },
      {
        title: "3D space models",
        description:
          "Single or connected rooms to create lifestyles, 360 room spins, or 3D tours",
      },
    ],
  },
  {
    title: "Photorealistic Images & Assets",
    description:
      "Manage all your assets in one place – from silos, 360 spins, and AR for your PDP to imagery and lifestyles for marketing and social.",
    image: "/features/cycle.png",
    featuresList: [
      {
        title: "Silo & dimensional images",
        description:
          "Clear product shots in multiple angles on a white or gray background, with or without dimensions",
      },
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "360 product spins",
        description:
          "A 360 animated spin of your product showcasing all angles",
      },
      {
        title: "AR view in room",
        description: "Uses an AR model to allow the view in room feature",
      },
    ],
  },
  {
    title: "Scene Creator Tool",
    description:
      "Scene Creator places your product into a styled vignette or room scene to create lifestyle images showing your product’s scale and use.",
    image: "/features/scene_creator.png",
    featuresList: [
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "3D tour of spaces",
        description:
          "A 360 spin of a room scene showcasing your product or designed space",
      },
      {
        title: "Design services available",
        description:
          "Work with a designer to style custom scenes for your product’s lifestyle images",
        isAdd: true,
      },
      {
        title: "Training available",
        description:
          "Get your team up to speed faster using our platform with a training session",
        isAdd: true,
      },
    ],
  },
  {
    title: "Free ALL3D Store Models",
    description:
      "You’ll have free access to the ALL3D store to use a wide variety of 3D models including products, props, spaces, and scene templates.",
    image: "/features/store_models.png",
    featuresList: [
      {
        title: "Free product & prop models",
        description:
          "Browse a variety of products and props to style with your product for a lifestyle image",
      },
      {
        title: "Free spaces",
        description:
          "Place your products and other props into a space to create a unique lifestyle environment",
      },
      {
        title: "Free styled scene templates",
        description:
          "Choose from a variety of styled scenes to place your product for a quick lifestyle image",
      },
    ],
  },
  {
    title: "Sharing & Cloud Storage",
    description:
      "With your asset library in the cloud, you can easily share and collaborate with your team on your 3D models, scenes, and images.",
    image: "/features/cloud_storage.png",
    featuresList: [
      {
        title: "Share and collaborate",
        description:
          "Ability to share and collaborate with your team on models and designs",
      },
      {
        title: "Cloud storage",
        description:
          "Unlimited cloud storage for your model and asset libraries",
      },
    ],
  },
];

export const faqs = [
  {
    question: "How does the free trial work?",
    answer:
      "Our free trial gives you full access to all features for 14 days. No credit card required.",
  },
  {
    question: "What features can I access once I have an ALL3D account?",
    answer:
      "With an ALL3D account, you get access to our complete suite of 3D modeling tools, rendering capabilities, and collaboration features.",
  },
  {
    question: "How do subscriptions work?",
    answer:
      "Subscriptions are billed monthly or annually. Choose the plan that best fits your needs and scale up or down as needed.",
  },
  {
    question:
      "Are there additional costs associated with a subscription? What if I need less or more each month?",
    answer:
      "Your subscription covers all core features. You can upgrade or downgrade your plan at any time to match your usage needs.",
  },
  {
    question: "How does an enterprise account work?",
    answer:
      "Enterprise accounts offer custom solutions, dedicated support, and advanced features for large organizations.",
  },
  {
    question: "What if I need something not included in a bundle?",
    answer:
      "Contact our sales team to discuss custom solutions and additional features not included in standard bundles.",
  },
  {
    question: "Is there training available?",
    answer:
      "Yes, we offer comprehensive training resources, including video tutorials, documentation, and live webinars.",
  },
  {
    question: "What is the cancellation or return policy?",
    answer:
      "You can cancel your subscription at any time. Refunds are processed according to our terms of service.",
  },
];

export const PLAN_DETAIL_MODALS = [
  {
    'title': 'ALL3D Free Trial',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3 AI-generated Models',
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Start your free trial'
  },
  {
    'title': 'ALL3D Starter Subscription',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '2 AI-generated Models',
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Proceed to PaymentProceed to Payment',
    'upgrade_text': 'Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.'
  },
  {
    'title': 'ALL3D Starter+ Subscription',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '10 AI-generated Models',
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '1 User License',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Proceed to Payment',
    'upgrade_text': 'Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.'
  },
  {
    'title': 'ALL3D Growth Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '2 Photorealistic Models',
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': '4 Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.png',
        'title': '8 Lifestyle Images',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/38512_FrontAngled2.png',
        'title': 'Up to 4 Product Variations',
        'subtext': 'Variants of your product in different colors, materials, etc.'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Clear product shots on a clean white or gray background',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player/API Integration',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '1 User License',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Proceed to Payment'
  },
  {
    'title': 'ALL3D Growth+ Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '4 Photorealistic Models',
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': '8 Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.png',
        'title': '16 Lifestyle Images',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/38512_FrontAngled2.png',
        'title': 'Up to 8 Product Variations',
        'subtext': 'Variants of your product in different colors, materials, etc.'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Clear product shots on a clean white or gray background',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player/API Integration',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '2 User Licenses',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Proceed to Payment'
  },
  {
    'title': 'ALL3D Enterprise Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': 'Photorealistic Models',
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': 'Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.png',
        'title': 'Lifestyle Images',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/38512_FrontAngled2.png',
        'title': 'Product Variations',
        'subtext': 'Variants of your product in different colors, materials, etc.'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Clear product shots on a clean white or gray background',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player/API Integration',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/configurator.png',
        'title': '3D Configurator',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/collaboration.png',
        'title': 'Collaboration Tool',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
    ],
    'extra_features': [
      {
        'image': '/PricingModal/small_pic.png',
        'title': 'Project & Asset Management',
      },
      {
        'image': '/PricingModal/managed.png',
        'title': 'Managed Design Services',
      },
      {
        'image': '/PricingModal/chat.png',
        'title': 'Account Manager',
      },
      {
        'image': '/PricingModal/support.png',
        'title': 'Dedicated Support',
      },
      {
        'image': '/PricingModal/cloud_small.png',
        'title': 'Sharing & Cloud Storage',
      },
      {
        'image': '/PricingModal/license_small.png',
        'title': 'Multiple user licenses',
      },
    ],
    'button_text': 'Schedule a Demo'
  }
]


export const BUNDLE_DETAIL_MODALS = [
  {
    'title': 'AI Creator Package',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '1 AI-generated Models',
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy AI Creator',
    'upgrade_text': 'Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.'
  },
  {
    'title': 'PDP Basic',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '1 Photorealistic Model',
        'subtext': 'High-quality product model to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy PDP Basic',
  },
  {
    'title': 'PDP Pro',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '1 Photorealistic Model',
        'subtext': 'High-quality product model to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': '4 Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.png',
        'title': '1 Lifestyle Image',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy PDP Pro',
  }
]

export const VIEW_MODAL_DICT = {
  'Free': 'ALL3D Free Trial',
  'Starter': 'ALL3D Starter Subscription',
  'Growth': 'ALL3D Growth Subscription',
  'Pro': 'ALL3D Pro Subscription',
  'Enterprise': 'ALL3D Enterprise Subscription',
  'Starter+': 'ALL3D Starter+ Subscription',
  'Growth+': 'ALL3D Growth+ Subscription',
  'AI Creator': 'AI Creator Package',
  'PDP Basic': 'PDP Basic',
  'PDP Pro': 'PDP Pro'
}

export const PLANS_NAMES_MAPPING = {
  'free_trial': 'Free Trial',
  'starter': 'Starter',
  'starter_plus': 'Starter+',
  'growth': 'Growth',
  'growth_plus': 'Growth+',
  'ai-creator': 'AI Creator',
  'pdp_basic': 'PDP Basic',
  'pdp_pro': 'PDP Pro'
}